import React from "react";
import { cn } from "../../lib/cn";

export function DescItemPlaceholder() {
  return null;
}
DescItemPlaceholder._antdDescItem = true;

export function Descriptions({
  bordered,
  column = { xs: 1, sm: 1, md: 2 },
  size,
  children,
  className,
  title,
}) {
  const nodes = [];

  React.Children.forEach(children, (ch) => {
    if (
      React.isValidElement(ch) &&
      ch.type &&
      ch.type._antdDescItem
    ) {
      nodes.push({
        label: ch.props.label,
        span: ch.props.span ?? 1,
        content: ch.props.children,
      });
    }
  });

  const cols =
    typeof column === "number"
      ? column
      : column.md ?? column.sm ?? column.xs ?? 1;

  return (
    <div
      className={cn(
        "rounded-xl",
        bordered && "border border-slate-200",
        size === "small" ? "text-sm" : "text-base",
        className
      )}
    >
      {title ? (
        <div
          className={cn(
            "border-b px-4 py-3 text-base font-semibold text-slate-900"
          )}
        >
          {title}
        </div>
      ) : null}
      <dl
        className={cn(
          "grid gap-x-10 gap-y-4 px-4 py-4",
          cols <= 1 && "grid-cols-1",
          cols === 2 && "grid-cols-1 md:grid-cols-2",
          cols >= 3 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
          bordered && !title && "pt-4"
        )}
      >
        {nodes.map((n, i) => (
          <div
            key={i}
            style={
              n.span && Number(n.span) > 1
                ? { gridColumn: `span ${Math.min(Number(n.span), cols)}` }
                : undefined
            }
          >
            <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {n.label}
            </dt>
            <dd
              className={cn(
                "mt-1 text-slate-900",
                size === "small" && "text-sm"
              )}
            >
              {n.content}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

Descriptions.Item = DescItemPlaceholder;
